import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=c6f0ae0e&scoped=true&"
import script from "./add-user.vue?vue&type=script&lang=js&"
export * from "./add-user.vue?vue&type=script&lang=js&"
import style0 from "./add-user.vue?vue&type=style&index=0&id=c6f0ae0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f0ae0e",
  null
  
)

export default component.exports